export const CUSTOMERS_BASE = "/marketing/customers";

export const customersHubPath = () => CUSTOMERS_BASE;
export const customersExistingPath = () => `${CUSTOMERS_BASE}/existing`;
export const customersLeadsPath = () => `${CUSTOMERS_BASE}/leads`;
export const customersTopinsPath = () => `${CUSTOMERS_BASE}/topins`;
export const leadPath = (id) => `${CUSTOMERS_BASE}/leads/${id}`;
export const leadStatPath = (k) => `${CUSTOMERS_BASE}/leads/stat/${k}`;
export const leadOccasionPath = (k) => `${CUSTOMERS_BASE}/leads/occasion/${k}`;

export const LEAD_STAT_MATCH = `${CUSTOMERS_BASE}/leads/stat/:statKey`;
export const LEAD_OCCASION_MATCH = `${CUSTOMERS_BASE}/leads/occasion/:occasionKey`;

export const isLeadsPath = (p) =>
  p === customersLeadsPath() || p.startsWith(`${customersLeadsPath()}/`);

export function legacyCustomersTarget(pathname) {
  // used by commit 2
  if (pathname === "/customers") return CUSTOMERS_BASE;
  if (pathname.startsWith("/customers/")) return `${CUSTOMERS_BASE}${pathname.slice(10)}`;
  return pathname; // identity-safe for anything else
}
